// @noflow

import { platform } from './utils';

/**
 * Generate a random ID used for async postMessage handling
 * @returns {string} random ID
 */
export const getRandomId = () =>
  Math.random()
    .toString(36)
    .substring(2, 15);

/**
 * Parse JSON postMessage event
 * @param {string} eventData event payload
 * @return {object} parsed event data
 */
export const parseEvent = eventData => {
  let obj = {};

  if (eventData) {
    try {
      obj = JSON.parse(eventData);
    } catch (e) {
      console.warn(`parseEvent unable to parse ${eventData}`);
    }
  }

  return obj;
};

/**
 * Returns true if the Bitmovin native SDK player should be used
 * @return {bool} isNativePlayer
 */
export const isNativePlayer = platform === 'ios' || platform === 'android';
